import React, { useRef, useEffect} from 'react';
import { Link } from "react-router-dom";
import Observer, { useInView } from 'react-intersection-observer';
import ArrowRightWhite from '../../images/arrow__right-white.svg';
import { GAfireEvent } from '../Tracking';

import { fireTag } from '../../libs/analytics';

import { isEs } from "../../libs/lang";

const content = isEs() ? require('../../contentES').default.housing.committed : require('../../content').default.housing.committed;

/* eslint-enable global-require */
const Committed = props => {
	const copy = content;
	const containerRef = useRef(null);

	let scrollCommitted = false;

	useEffect(() => {
		window.addEventListener('scroll',()=>{
			if(window.location.href.includes('/housing/') && !scrollCommitted && document.querySelector('#committed-process').getBoundingClientRect().top <= (document.querySelector('nav').getBoundingClientRect().height + (window.innerHeight / 2))){
				scrollCommitted = true;
				fireTag('S5');
			}
		});
	},[])

	return (
		<section className="housing__committed" id="committed-process" ref={containerRef}>
			<Observer
				tag="div"
				className="container__copy"
				threshold={0.5}
				triggerOnce
				onChange={inView => { 
					
				}}
			>
				<h2 tabIndex="-1">{copy.headline}</h2>
				<div className="committed-link--container">
					<Link
						to="/"
						onClick={() => {
							fireTag("C5");
						}}
						className="p">
						{copy.copy}
					</Link>
					<Link
						to="/"
						onClick={() => {
							fireTag("C5");
						}}
						className="arrow"
					>
						<div className="container__arrow">
							<img role="presentation" alt="White Right Arrow" src={ArrowRightWhite}/>
						</div>
					</Link>
				</div>
			</Observer>
		</section>
	);
};

export default Committed;
